import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3qwvtgh46: FaireProductEntity = {
  token: "p_g3qwvtgh46",
  type: "product",
  name: "Puzzle Wood Peg Jigsaw Noah's Ark",
  brandToken: "b_29xxo8ggi7",
  brandName: "Swanson Christian Products",
  imageUrl:
    "https://cdn.faire.com/fastly/a5b47b289322820c06e56b4b624be29f1ac13f6b8b4c6d0d321345a65919cf7c.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d5500d83068e3c315666769e2852f5966320ed3451b72e25d2d686208ff3d09.webp",
    "https://cdn.faire.com/fastly/5bbfb8d704dbb708e948f01649ed1de4c70867afda821f9ee41c23c0c0a65e74.webp",
    "https://cdn.faire.com/fastly/c72e000c62c8dcfbeb6f22117e99b5f2b8ce2d48ae64a541aca256a4fe7baed5.jpeg",
    "https://cdn.faire.com/fastly/5c6b849626f17705cb9fa235eb1a2952c01ec9fc7ddd1875d2969b3a0a483773.jpeg",
    "https://cdn.faire.com/fastly/1d2b9597b337fc63b4f69ff6ebde6b14b052a036d870b68a8faccf2b009bccfd.webp",
  ],
  priceDollars: 9.91,
  description:
    "Teach your toddler and babies about the different animals and the story of Noah's Ark in a colorful way that they will love! Inspire faith in God in your little ones or as a Birthday or Christmas gift with the story of Noah's ark while encouraging creativity and hand-eye coordination. Made of smooth, sturdy wood with sanded and rounded edges, this puzzle is perfectly safe for babies, toddlers, and young children to play with. Each block features a colorful element from the beloved story of Noah's Ark, making this puzzle both educational and engaging. Your child will love matching the animals and pieces together, building their cognitive functions and improving their hand-eye coordination.\n\nMeasuring 8.75\" x 8.75\" x .25\", this puzzle is the perfect size for little hands to grasp and manipulate. The pick-up pegs on each block make it easy for children to pick up and move the pieces, and the jigsaw pieces help to enhance their fine motor skills and dexterity. Our wooden block puzzle is not only a fun toy for kids to play with but also an excellent tool for parents and educators to use in teaching young children about Noah's Ark and the importance of caring for animals. With its vibrant colors and durable construction, this puzzle is sure to provide hours of entertainment and learning for your little ones.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:34.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
